import { render, staticRenderFns } from "./ProductInfoBlock.vue?vue&type=template&id=1f7a2bb0"
import script from "./ProductInfoBlock.vue?vue&type=script&lang=js"
export * from "./ProductInfoBlock.vue?vue&type=script&lang=js"
import style0 from "./ProductInfoBlock.vue?vue&type=style&index=0&id=1f7a2bb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports